export default __webpack_public_path__ + "static/media/mainLogo.7571378f.svg";